import ko from "knockout";
import register from "flow/knockout/register";

function formatNumber(x: string | number) {
    if (x === undefined || x === null || x === "") {
        x = "0";
    }

    if (typeof x === "string") {
        x = x.replace(/\s/gi, "");
    }

    const number = typeof x === "number" ? x : parseInt(x, 10);

    if (isNaN(number) || number === 0) {
        return "";
    }

    const formatted = number;

    //var regex = new RegExp('^(-?\\d+)$');
    //formatted = formatted.replace(regex, '$1');
    return formatted;
}

function reverseFormat(x: string | number): number {
    if (x === undefined || x === null || x === "") {
        x = "0";
    }

    if (typeof x === "string") {
        const regex = new RegExp("^(\\d+)$");
        const formatted = x.replace(regex, "$1");
        const parsedValue = parseInt(formatted);
        return isNaN(parsedValue) ? 0 : parsedValue;
    } else {
        return isNaN(x) ? 0 : x;
    }
}

function allowOnlyNumeric(event: KeyboardEvent) {
    // Allow: backspace, delete, tab, escape, and enter
    if (
        event.keyCode === 46 ||
        event.keyCode === 8 ||
        event.keyCode === 9 ||
        event.keyCode === 27 ||
        event.keyCode === 13 ||
        // Allow: Ctrl+A
        (event.keyCode === 65 && event.ctrlKey === true) ||
        // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 39)
    ) {
        // let it happen, don't do anything
        return;
    } else {
        // Ensure that it is a number and stop the keypress
        if (
            event.shiftKey ||
            ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105))
        ) {
            event.preventDefault();
        }
    }
}

/*

    Explanation of the RegExp used above:

    ^(\\d+)$

        ^        = pattern must match from the start of the string

        (\\d+)   = 1 or more digits
                   - the brackets capture the matched string
                     to be used in the replace function as $1

        [^\\d]   = any character but a digit
                   - this includes letters, whitespace and
                     punctutation (any character but 0-9)

        $        = pattern must match to the end of the string
                   - here we've used ^...$ so the pattern must
                     match the entire string
    */

register.registerKnockoutBinding("intSpaceIfZeroFormatter", {
    init: function (element, valueAccessor) {
        let observable = valueAccessor();

        element.addEventListener("keydown", allowOnlyNumeric);
        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            element.removeEventListener("keydown", allowOnlyNumeric);
        });

        const interceptor = ko
            .computed({
                read: function () {
                    const value = ko.isObservable(observable) ? observable() : observable;
                    return formatNumber(value);
                },
                write: function (newValue) {
                    if (ko.isObservable(observable)) {
                        const oldValue = observable();
                        const valueToWrite = reverseFormat(newValue);

                        //only write if it changed
                        if (valueToWrite !== oldValue) {
                            observable(valueToWrite);
                        } else {
                            //if the rounded value is the same, but a different value was written, force a notification for the current field
                            if (newValue !== oldValue) {
                                observable.notifySubscribers(valueToWrite);
                            }
                        }
                    } else {
                        observable = reverseFormat(newValue);
                    }
                }
            })
            .extend({ notify: "always" });

        if (element.tagName === "INPUT") {
            ko.applyBindingsToNode(element, {
                value: interceptor
            });
        } else {
            ko.applyBindingsToNode(element, {
                text: interceptor
            });
        }
    }
});

(ko.validation as any).makeBindingHandlerValidatable("intSpaceIfZeroFormatter");
